export const API_ACCESS_TOKEN_LIST = 'API_ACCESS_TOKEN_LIST';
export const API_ACCESS_TOKEN_CLEAR = 'API_ACCESS_TOKEN_CLEAR';